import React from "react";
import { Navbar } from "../home/navbar/Navbar";
import { PostEvent } from "./PostEvent";
export const Event = () => {
    return(
        <>
        <Navbar />
        <PostEvent />
        </>
    )
    }